module.exports = __webpack_public_path__ + "static/media/mini_audi_1.e23ef5be.jpeg";